import {Concept} from "@/features/application/api/applicationModels";

export interface IConceptDriveThruThresholdsConfig {
    thresholdSeconds: number;
    speakerThresholdSec: number;
    queueThresholdSec: number;
    windowThresholdSec: number;
    labels: {
        total: string;
        menu: string;
        queue: string;
        window: string;
    };
}

// TODO: Source these values from the database
export const CONCEPT_DRIVE_THRU_THRESHOLDS_CONFIGS: Partial<
    Record<Concept, IConceptDriveThruThresholdsConfig>
> = {
    [Concept.Taco]: {
        thresholdSeconds: 3 * 60 + 45,
        speakerThresholdSec: 75,
        queueThresholdSec: 90,
        windowThresholdSec: 75,
        labels: {
            total: "Drive-Thru SWS",
            menu: "Menu Time",
            queue: "Queue Time",
            window: "Window Time"
        }
    },
    [Concept.Popeyes]: {
        thresholdSeconds: 3 * 60 + 45,
        speakerThresholdSec: 75,
        queueThresholdSec: 90,
        windowThresholdSec: 75,
        labels: {
            total: "Drive-Thru SOS",
            menu: "Menu SWS",
            queue: "Queue SWS",
            window: "Window SOS"
        }
    }
};

const DEFAULT_CONCEPT_CONFIG = CONCEPT_DRIVE_THRU_THRESHOLDS_CONFIGS[Concept.Taco]!;

export function getConceptDriveThruThresholdsConfig(
    concept: Concept
): IConceptDriveThruThresholdsConfig {
    return CONCEPT_DRIVE_THRU_THRESHOLDS_CONFIGS[concept] ?? DEFAULT_CONCEPT_CONFIG;
}
